const ssoProviders = {
    test: "TestProvider",
    fmi: "FmiSsoProvider",
    ussteel: "UsSteelSsoProvider"
  };

  export default ssoProviders;